import { render, staticRenderFns } from "./IconCrossBold.vue?vue&type=template&id=e39da908&"
import script from "./IconCrossBold.vue?vue&type=script&lang=js&"
export * from "./IconCrossBold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports